export default {
  path: '/common',
  component: () => import('@/views/common/Index'),
  redirect: { name: 'users' },
  children: [
    {
      path: 'users/permissions',
      name: 'users-permissions',
      component: () => import('@/views/common/permissions/Index'),
      meta: { title: 'Users → Permissions', roles: ['general_manager'], access: { mode: 'general-manager' } }
    },
    {
      path: 'users/permissions/new',
      name: 'users-permissions-new',
      component: () => import('@/views/common/permissions/Index'),
      meta: { title: 'New permission role', roles: ['general_manager'], access: { mode: 'general-manager' } }
    },
    {
      path: 'users/permissions/:id',
      name: 'users-permissions-detail',
      component: () => import('@/views/common/permissions/Index'),
      meta: { title: 'Permission role', roles: ['general_manager'], access: { mode: 'general-manager' } }
    },
    {
      path: 'builder',
      name: 'builder',
      component: () => import('@/views/common/TestFormBuilder'),
      meta: {
        title: 'Builder',
        roles: ['general_manager']
      }
    },
    {
      path: 'users',
      name: 'users',
      component: () => import('@/views/common/Users'),
      meta: {
        title: 'Users',
        roles: ['general_manager']
      }
    },
    {
      path: 'dictionaries',
      name: 'dictionaries',
      component: () => import('@/views/common/dictionaries/Index'),
      redirect: { name: 'locations' },
      children: [
        {
          path: '',
          name: 'dictionaries-layout',
          component: () => import('@/views/common/dictionaries/Layout'),
          redirect: { name: 'locations' },
          children: [
            {
              path: 'locations',
              name: 'locations',
              component: () => import('@/views/common/dictionaries/Locations'),
              meta: {
                title: 'Locations',
                roles: ['general_manager']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'currency-exchanger',
      name: 'currency-exchanger',
      component: () => import('@/views/common/CurrencyExchange'),
      meta: {
        title: 'Currency exchanger',
        roles: ['general_manager', 'finance_manager']
      }
    },
    {
      path: 'signboard',
      name: 'signboard',
      component: () => import('@/views/common/Signboard'),
      meta: {
        title: 'Signboard generator',
        roles: ['general_manager', 'hotel_reception', 'operations_supervisor']
      }
    },
    {
      path: 'qr-service',
      name: 'qr-service',
      component: () => import('@/views/common/QRService'),
      meta: {
        title: 'QR Service',
        roles: ['general_manager']
      }
    },
  ]
}
